import { useState } from 'react';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { type AgentSection } from '../../state/createProjectSlice';
import { selectAnnotationAgentSections } from '../../state/selector';

// TODO: cleanup with cp_annotation_createproject_agent ff

interface UseAgentSectionsResult {
  savedSections: AgentSection[];
  /** IDs of cards added but never saved. They are not in Redux. */
  newSectionIds: string[];
  handleAddSection: () => void;
  handleNewSectionResolved: (id: string) => void;
}

/** Saved sections come from Redux in insertion order; new cards are kept locally until saved. */
export const useAgentSections = (): UseAgentSectionsResult => {
  const savedSections = useAppSelector(selectAnnotationAgentSections);
  const [newSectionIds, setNewSectionIds] = useState<string[]>([]);

  const handleAddSection = () => {
    setNewSectionIds((current) => [...current, crypto.randomUUID()]);
  };

  const handleNewSectionResolved = (id: string) => {
    setNewSectionIds((current) => current.filter((newId) => newId !== id));
  };

  return { savedSections, newSectionIds, handleAddSection, handleNewSectionResolved };
};
